import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * BootstrapAlertModal
 * Menggantikan alert bawaan browser (window.alert) dengan Modal Bootstrap yang profesional,
 * elegan, dan responsif dengan penyesuaian tema warna (Success, Warning, Danger, Info).
 */
const BootstrapAlertModal = () => {
  const [alertData, setAlertData] = useState({
    show: false,
    title: 'Pemberitahuan Sistem SIMRS',
    message: '',
    variant: 'primary',
    icon: 'bi-info-circle-fill'
  });

  useEffect(() => {
    // Simpan referensi alert bawaan browser
    const originalAlert = window.alert;

    // Override window.alert dengan modal bootstrap interaktif
    window.alert = (msg) => {
      const message = typeof msg === 'object' ? JSON.stringify(msg) : String(msg ?? '');
      const lower = message.toLowerCase();

      let variant = 'primary';
      let icon = 'bi-info-circle-fill';
      let title = 'Informasi Sistem SIMRS';

      if (
        lower.includes('gagal') ||
        lower.includes('error') ||
        lower.includes('kesalahan') ||
        lower.includes('tidak bisa') ||
        lower.includes('terjadi kesalahan')
      ) {
        variant = 'danger';
        icon = 'bi-x-circle-fill';
        title = 'Terjadi Kesalahan';
      } else if (
        lower.includes('berhasil') ||
        lower.includes('sukses') ||
        lower.includes('selesai') ||
        lower.includes('saved') ||
        lower.includes('tersimpan')
      ) {
        variant = 'success';
        icon = 'bi-check-circle-fill';
        title = 'Berhasil';
      } else if (
        lower.includes('peringatan') ||
        lower.includes('perhatian') ||
        lower.includes('warning') ||
        lower.includes('tidak ada') ||
        lower.includes('wajib') ||
        lower.includes('harap') ||
        lower.includes('pilih') ||
        lower.includes('kosong') ||
        lower.includes('belum')
      ) {
        variant = 'warning';
        icon = 'bi-exclamation-triangle-fill';
        title = 'Perhatian';
      }

      setAlertData({
        show: true,
        title,
        message,
        variant,
        icon
      });
    };

    return () => {
      window.alert = originalAlert;
    };
  }, []);

  const handleClose = () => {
    setAlertData(prev => ({ ...prev, show: false }));
  };

  return (
    <Modal
      show={alertData.show}
      onHide={handleClose}
      centered
      backdrop="static"
      style={{ zIndex: 999999 }}
      dialogClassName="bootstrap-alert-dialog"
    >
      <Modal.Header
        closeButton
        closeVariant="white"
        style={{
          background:
            alertData.variant === 'danger'
              ? 'linear-gradient(135deg, #b91c1c 0%, #dc2626 100%)'
              : alertData.variant === 'success'
              ? 'linear-gradient(135deg, #047857 0%, #059669 100%)'
              : alertData.variant === 'warning'
              ? 'linear-gradient(135deg, #d97706 0%, #f59e0b 100%)'
              : 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)',
          color: '#ffffff',
          borderBottom: 'none',
          padding: '12px 18px',
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px'
        }}
      >
        <Modal.Title style={{ fontSize: '0.92rem', fontWeight: 700 }} className="d-flex align-items-center gap-2">
          <i className={`bi ${alertData.icon} fs-5`}></i>
          <span>{alertData.title}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '22px 22px', background: '#f8fafc' }}>
        <div className="d-flex align-items-start gap-3">
          <div
            style={{
              width: '42px',
              height: '42px',
              borderRadius: '10px',
              background:
                alertData.variant === 'danger'
                  ? '#fee2e2'
                  : alertData.variant === 'success'
                  ? '#dcfce7'
                  : alertData.variant === 'warning'
                  ? '#fef3c7'
                  : '#eff6ff',
              color:
                alertData.variant === 'danger'
                  ? '#dc2626'
                  : alertData.variant === 'success'
                  ? '#16a34a'
                  : alertData.variant === 'warning'
                  ? '#d97706'
                  : '#2563eb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
            }}
          >
            <i className={`bi ${alertData.icon} fs-4`}></i>
          </div>
          <div style={{ fontSize: '0.85rem', color: '#1e293b', lineHeight: 1.5, wordBreak: 'break-word', paddingTop: '2px' }}>
            {alertData.message}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ background: '#f1f5f9', borderTop: '1px solid #e2e8f0', padding: '10px 18px' }}>
        <Button
          variant={alertData.variant === 'warning' ? 'warning' : alertData.variant}
          size="sm"
          onClick={handleClose}
          autoFocus
          className="fw-bold px-4 shadow-sm text-white"
          style={{
            borderRadius: '7px',
            fontSize: '0.8rem',
            background:
              alertData.variant === 'warning'
                ? '#d97706'
                : alertData.variant === 'danger'
                ? '#dc2626'
                : alertData.variant === 'success'
                ? '#059669'
                : '#2563eb',
            borderColor: 'transparent'
          }}
        >
          <i className="bi bi-check-lg me-1"></i> Mengerti
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BootstrapAlertModal;
